import type { AllHTMLAttributes, ReactNode } from "react";

import styles from "./tabs-text.module.css";

export type TabsTextProps = {
  children: ReactNode;
} & AllHTMLAttributes<HTMLDivElement>;

export function TabsText({ children, ...props }: TabsTextProps) {
  return (
    <div {...props} className={styles.Container}>
      {children}
    </div>
  );
}
